import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux"
import { createSelector } from 'reselect';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody } from "reactstrap";
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import getChartColorsArray from '../../Components/Common/ChartsDynamicColor';
import ReactApexChart from "react-apexcharts";
import Preloader from '../../Components/Common/Preloader';
import { getImpressionByDevice, setImpressionByDeviceData, toggleImpressionModal } from '../../slices/analytics/reducer';
import DetailCard from './DetailCard';
import { getImpressionTable } from '../../slices/analytics/thunk';

function ImpressionByDevice() {
  const dispatch = useDispatch();
  const [chartData, setChartData] = useState([]);
  const [labels, setLabels] = useState([]);
  const dataColors = ["--adc-primary", "--adc-warning", "--adc-info", "--adc-success", "--adc-danger", "--adc-orange"];

  const selectStates = createSelector((state) => state,
    (state) => ({
      impressionByDeviceLoader: state.Analytics.impressionByDeviceLoader,
      impressionByDeviceData: state.Analytics.impressionByDeviceData,
      getImpressionByDevice: state.Analytics.getImpressionByDevice,
      analyticsCampaigns: state.Analytics.analyticsCampaigns,
    }));

  const { impressionByDeviceLoader, impressionByDeviceData, getImpressionByDevice, analyticsCampaigns } = useSelector(selectStates);


  function openImpressionByDevice() {
    dispatch(getImpressionTable(analyticsCampaigns));
  }

  useEffect(() => {
    if (impressionByDeviceData && typeof impressionByDeviceData === 'object') {
      if (Object.keys(impressionByDeviceData).length !== 0) {
        setChartData(Object.values(impressionByDeviceData));
        setLabels(Object.keys(impressionByDeviceData));  
      } else {
        setChartData([0,0,0,0]);
        setLabels(['tv', 'ios', 'android', 'pc']);
      }
    } else {
      setChartData([]);
      setLabels([]);
    }
  }, [impressionByDeviceData]);

  return (
    <React.Fragment>
      {impressionByDeviceLoader ?
        <Card className='card-height-100 align-items-center justify-content-center'>
          <Preloader isComponentLoader={true} width={150} height={150} />
        </Card>
        : chartData.length >= 1 ?
          <Card className="card-height-100">
            <CardHeader className="align-items-center d-flex">
              <p className="mb-0 flex-grow-1">Users by Device</p>
              <div className="flex-shrink-0">
              </div>
            </CardHeader>
            <CardBody className='d-flex flex-column align-items-center justify-content-center'>
              <div dir="ltr">
                <UsersByDeviceCharts series={chartData} dataColors={JSON.stringify(dataColors)} labels={labels} />
              </div>

              <div className="table-responsive mt-3">
                <table className="table table-borderless table-sm table-centered align-middle table-nowrap mb-0">
                  <tbody className="border-0">
                    {chartData.length > 0 ? chartData.map((item, idx) => {
                      return (
                        <tr>
                          <td>
                            <h4 className='text-truncate fs-14 fs-medium mb-0'>
                              <i className="ri-stop-fill align-middle fs-18 text-primary me-2" style={{ color: `var(${dataColors[idx]}) !important` }}></i>
                              {labels[idx].charAt(0).toUpperCase() + labels[idx].slice(1)} Users</h4>
                          </td>
                          <td>
                            <p className='text-muted mb-0'>
                              <FeatherIcon icon="users" className='me-2 icon-sm' />
                              {item.toLocaleString('en')}
                            </p>
                          </td>
                        </tr>
                      )
                    })
                      : null}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card> :
          <DetailCard color='info'
            textColor='primary'
            avatar="bx bxs-devices"
            header="Device-Based Impressions Overview"
            text="Monitor the number of impressions by device type to better understand your audience and tailor your ads for optimal performance across different platforms."
            onClick={openImpressionByDevice}
          />
      }

    </React.Fragment>
  )
}

export default ImpressionByDevice;

function UsersByDeviceCharts({ dataColors, series, labels = [] }) {
  var dountchartUserDeviceColors = getChartColorsArray(dataColors);
  const options = {
    labels: labels,
    chart: {
      type: "donut",
      height: 219,
    },
    plotOptions: {
      pie: {
        size: 100,
        donut: {
          size: "76%",
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
      position: 'bottom',
      horizontalAlign: 'center',
      offsetX: 0,
      offsetY: 0,
      markers: {
        width: 20,
        height: 6,
        radius: 2,
      },
      itemMargin: {
        horizontal: 12,
        vertical: 0
      },
    },
    stroke: {
      width: 0
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value.toLocaleString('en') + ' Users';
        }
      },
      tickAmount: 4,
      min: 0
    },
    colors: dountchartUserDeviceColors,
  };
  return (
    <React.Fragment>
      <ReactApexChart dir="ltr"
        options={options}
        series={series}
        type="donut"
        height="219"
        className="apex-charts"
      />
    </React.Fragment>
  );
};
